export default "__VITE_ASSET__CB$rpvg$__"